import { useReducer } from "react";

const updateReducer = (num: number): number => (num + 1) % 1_000_000;

/**
 * @title useUpdate
 * @description Returns a function that can be called to force a component to re-render.
 */
export function useUpdate(): () => void {
  const [, update] = useReducer(updateReducer, 0);

  return update;
}
